import { render, staticRenderFns } from "./OverlayTrigger.vue?vue&type=template&id=156a0f80&"
import script from "./OverlayTrigger.vue?vue&type=script&lang=js&"
export * from "./OverlayTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports